import React, { useState, useEffect } from "react";
import { Galleria } from "primereact/galleria";
import "./styles.css";
export default function Gallery({
	images = [
		{
			itemImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria1.jpg",
			thumbnailImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria1s.jpg",
			alt: "Description for Image 1",
			title: "Title 1",
		},
		{
			itemImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria2.jpg",
			thumbnailImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria2s.jpg",
			alt: "Description for Image 2",
			title: "Title 2",
		},
		{
			itemImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria3.jpg",
			thumbnailImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria3s.jpg",
			alt: "Description for Image 3",
			title: "Title 3",
		},
		{
			itemImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria4.jpg",
			thumbnailImageSrc:
				"https://primefaces.org/cdn/primereact/images/galleria/galleria4s.jpg",
			alt: "Description for Image 4",
			title: "Title 4",
		},
	],
}) {
	const responsiveOptions = [
		{
			breakpoint: "991px",
			numVisible: 4,
		},
		{
			breakpoint: "767px",
			numVisible: 3,
		},
		{
			breakpoint: "575px",
			numVisible: 1,
		},
	];

	// const next = () => {
	// 	setActiveIndex((prevState) =>
	// 		prevState === images.length - 1 ? 0 : prevState + 1
	// 	);
	// };

	// const prev = () => {
	// 	setActiveIndex((prevState) => (prevState === 0 ? 0 : prevState - 1));
	// };

	const itemTemplate = (item) => {
		return (
			<img src={item.itemImageSrc} alt={item.alt} style={{ height: "70vh" }} />
		);
	};

	const thumbnailTemplate = (item) => {
		return (
			<img src={item.thumbnailImageSrc} alt={item.alt} style={{ height: 50 }} />
		);
	};

	return (
		<div className="card">
			<Galleria
				value={images}
				responsiveOptions={responsiveOptions}
				numVisible={5}
				// style={{ maxWidth: "640px" }}
				item={itemTemplate}
				thumbnail={thumbnailTemplate}
				// activeIndex={0}
				// onItemChange={(e) => console.log(e)}
			/>
		</div>
	);
}
